commusoftCommon.directive('replaceContent', function() {
    return {
        replace: true,
        link: function($scope, element, attrs) {
            element.append($scope.transData);
        }
    }
});